import {
	Breakpoints,
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import { PortalContext } from '../../context/portal-context';
import { IdWeChargePopupLayer } from '../id-wecharge/Id-wecharge-popup-layer';
import { PromotionPopupLayer } from '../promotion-manager/promotion-popup-layer';
import { AlertType, CombinedAlert } from './alerts-type';
import { AlertCard } from './components/alert-card';
import { PersonBenefits } from '@esportal/portal-service';
import { noVehicleOrder2025 } from '../../helpers/alert-utils';
import { AlertsContainer, AlertsStackedContainer, FlexItem } from './ui/alerts-styles';
import { useAlertsData } from './hooks/use-alerts-data';

export const Alerts: React.FC<{
	personBenefits: PersonBenefits;
}> = ({ personBenefits }) => {
	const { portalService } = useContext(PortalContext);
	const vehicles = portalService.getPersonVehicles().getValue();

	//const userPromotions = userData?.portalUser.data.promotions;
	const promotionLayerRef = React.useRef<HTMLDivElement | null>(null);
	const [alertTypePromotion, setAlertTypePromotion] = React.useState<AlertType | null>(null);
	const [isPromotionPopupVisible, setIsPromotionPopupVisible] = React.useState<boolean>(false);

	const IdWeChargeLayerRef = React.useRef<HTMLDivElement | null>(null);
	const [isIdWeChargePopupVisible, setisIdWeChargePopupVisible] = React.useState<boolean>(false);

	const filteredFirstThreeAlerts = useAlertsData(personBenefits, portalService);

	return (
		<>
			<PromotionPopupLayer
				alertType={alertTypePromotion}
				isPromotionPopupVisible={isPromotionPopupVisible}
				setIsPromotionPopupVisible={setIsPromotionPopupVisible}
				promotionLayerRef={promotionLayerRef}
			/>

			{noVehicleOrder2025(vehicles) && (
				<IdWeChargePopupLayer
					IsIdWeChargePopUpVisible={isIdWeChargePopupVisible}
					setIsIdWeChargePopUpVisible={setisIdWeChargePopupVisible}
					IdWeChargeLayerRef={IdWeChargeLayerRef}
				/>
			)}

			{filteredFirstThreeAlerts.length > 0 && (
				<AlertsContainer
					data-testid="alerts"
					padding={{
						top: {
							[Breakpoints.default]: ContainerPadding.dynamic0250,
							[Breakpoints.b560]: ContainerPadding.dynamic0150,
						},
						bottom: ContainerPadding.dynamic0250,
					}}
					stretchContent
				>
					<Container data-testid="alerts-title" stretchContent>
						<Text appearance={TokenTextAppearance.headline500} color={TokenTextColor.primary}>
							{'Que no se\u00A0'}
							<Text appearance={TokenTextAppearance.headline500} color={TokenTextColor.primary} bold>
								{'te escape'}
							</Text>
						</Text>
					</Container>

					<AlertsStackedContainer
						data-testid="alerts-cards-container"
						padding={{
							top: {
								[Breakpoints.default]: ContainerPadding.dynamic0150,
							},
						}}
					>
						{filteredFirstThreeAlerts.map((alert: CombinedAlert, index) => {
							const alertsCount = filteredFirstThreeAlerts.length;
							const shouldHavePaddingRight = (alertsCount > 2 && index === 1) || (alertsCount === 2 && index === 0);
							const shouldHavePaddingBottom = alertsCount > 2 && index === 0;

							return (
								<FlexItem
									key={index}
									className="flex-item"
									paddingRight={shouldHavePaddingRight}
									paddingBottom={shouldHavePaddingBottom}
								>
									<AlertCard
										alert={alert}
										className={`alert-card-${index}`}
										numberOfAlerts={alertsCount}
										alertPosition={index}
										setIsIdWeChargePopUpVisible={setisIdWeChargePopupVisible}
										setIsPromotionPopupVisible={setIsPromotionPopupVisible}
										setAlertTypePromotion={setAlertTypePromotion}
									/>
								</FlexItem>
							);
						})}
					</AlertsStackedContainer>
				</AlertsContainer>
			)}
		</>
	);
};
